<template>
  <v-container
    id="user-list"
  >
    <v-row>
      <v-col><h2>Editar Cargo</h2></v-col>
      <v-col
        class="text-right"
      >
        <v-btn
            outlined
            color="primary"
            class="ml-3"
            :to="'/sala-principal/:id/cargos-funcoes'"
          >
            Voltar para Lista de Cargos
        </v-btn>
      </v-col>
    </v-row>

   <v-row>
      <v-col>
        <v-text-field
          label="Nome do Cargo"
          name="nome"
          type="text"
          v-model="payload.nomeCargo"
          required
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Missão"
          name="nome"
          type="text"
          required
          v-model="payload.missao"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Orgão"
          name="email"
          type="email"
          required
          v-model="payload.orgao"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Numero Atual Interno"
          name="email"
          type="email"
          required
          v-model="payload.numeroAtualInterno"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Numero Atual Externo"
          name="email"
          type="email"
          required
          v-model="payload.numeroAtualExterno"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Numero Desejavel Interno"
          name="email"
          type="email"
          required
          v-model="payload.numeroDesejavelInterno"
        ></v-text-field>
      </v-col>
    </v-row>

     <v-row>
      <v-col>
        <v-text-field
          label="Numero Desejavel Externo"
          name="email"
          type="email"
          required
          v-model="payload.numeroDesejavelExterno"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-col
        cols="12"
        md="12"
      >
        <v-textarea
          name="input-7-1"
          label="Nome Ocupantes"
          hint="Hint text"
          v-model="payload.nomeOcupantes"
        ></v-textarea>
    </v-col>

    <v-col
        cols="12"
        md="12"
      >
        <v-textarea
          name="input-7-1"
          label="Serviços Executados"
          hint="Hint text"
          v-model="payload.servicosExecutados"
        ></v-textarea>
    </v-col>

    <v-col
        cols="12"
        md="12"
      >
        <v-textarea
          name="input-7-1"
          label="Serviços Não Executados"
          hint="Hint text"
          v-model="payload.servicosNaoExecutados"
        ></v-textarea>
    </v-col>

    <v-row>
      <v-col>
        <v-btn
          outlined
          color="primary"
          class="ml-3"
          @click="updateUser"
          :disabled=desabilitarEnvio
        >
          Atualizar Cargo
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { cargosFuncoes } from '../API/cargosFuncoesApi'
import { mapActions } from 'vuex'

export default {

  data () {
    return {
      payload: [
        {
          cargosFuncoesId: 0,
          nomeCargo: '',
          municipioId: 0,
          missao: '',
          orgao: '',
          nomeOcupantes: '',
          servicosExecutados: '',
          servicosNaoExecutados: '',
          numeroAtualInterno: 0,
          numeroAtualExterno: 0,
          numeroDesejavelInterno: 0,
          numeroDesejavelExterno: 0
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    getCargos () {
      this.setLoading(true)

      cargosFuncoes.get(this.$route.params.id)
        .then(resp => {
          this.payload = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter usuário')
        })
    },
    updateUser () {
      this.setLoading(true)

      let formData = new FormData()

      formData.append('cargosFuncoesId', this.payload.cargosFuncoesId)
      formData.append('nomeCargo', this.payload.nomeCargo)
      formData.append('missao', this.payload.missao)
      formData.append('orgao', this.payload.orgao)
      formData.append('nomeOcupantes', this.payload.nomeOcupantes)
      formData.append('servicosExecutados', this.payload.servicosExecutados)
      formData.append('servicosNaoExecutados', this.payload.servicosNaoExecutados)
      formData.append('numeroAtualInterno', this.payload.numeroAtualInterno)
      formData.append('numeroAtualExterno', this.payload.numeroAtualExterno)
      formData.append('numeroDesejavelInterno', this.payload.numeroDesejavelInterno)
      formData.append('numeroDesejavelExterno', this.payload.numeroDesejavelExterno)

      cargosFuncoes.update(formData)
        .then(resp => {
          this.$notification.success('Dados atualizado com sucesso!')
          this.getCargos()
          this.setLoading(false)
          this.$router.push('/sala-principal/:id/cargos-funcoes')
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao atualizar os dados')
        })
    }
  },
  mounted () {
    this.getCargos()
  }
}
</script>
